// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"56a35bd5","28":"cafe36b7","239":"d59c62eb","434":"0ad6643c","676":"d0f143b1","711":"d5043f2f","835":"dc20dfc2","910":"73f3eacc"}[chunkId] + ".chunk.css";
};